import { Table, Button } from '@enterprise-ui/canvas-ui-react';
import React from 'react';
import { checkDateInList, checkSameDate, formatDate } from '../utils/utility.js';

function RawCalendarDates(_ref) {
  var autoOk = _ref.autoOk,
    disableDates = _ref.disableDates,
    format = _ref.format,
    monthArr = _ref.monthArr,
    selectedDate = _ref.selectedDate,
    setDate = _ref.setDate,
    setIsCalendarVisible = _ref.setIsCalendarVisible;
  var isDateDisabled = function isDateDisabled(date) {
    return disableDates && (disableDates.past && date.past || disableDates.future && date.future || disableDates.weekdays && date.weekday || disableDates.weekends && date.weekend || disableDates.before && date.before || disableDates.except && !checkDateInList(date, disableDates.except) || disableDates.only && checkDateInList(date, disableDates.only));
  };
  return /*#__PURE__*/React.createElement(Table, {
    name: "date picker",
    className: "C-DatePicker__Table"
  }, /*#__PURE__*/React.createElement(Table.Head, null, /*#__PURE__*/React.createElement(Table.Row, {
    key: "weekdays",
    justify: "flex-end"
  }, /*#__PURE__*/React.createElement(Table.Header, {
    key: "weekday_su",
    className: "C-DatePicker__DataCell"
  }, "Su"), /*#__PURE__*/React.createElement(Table.Header, {
    key: "weekday_mo",
    className: "C-DatePicker__DataCell"
  }, "Mo"), /*#__PURE__*/React.createElement(Table.Header, {
    key: "weekday_tu",
    className: "C-DatePicker__DataCell"
  }, "Tu"), /*#__PURE__*/React.createElement(Table.Header, {
    key: "weekday_we",
    className: "C-DatePicker__DataCell"
  }, "We"), /*#__PURE__*/React.createElement(Table.Header, {
    key: "weekday_th",
    className: "C-DatePicker__DataCell"
  }, "Th"), /*#__PURE__*/React.createElement(Table.Header, {
    key: "weekday_fr",
    className: "C-DatePicker__DataCell"
  }, "Fr"), /*#__PURE__*/React.createElement(Table.Header, {
    key: "weekday_sa",
    className: "C-DatePicker__DataCell"
  }, "Sa"))), /*#__PURE__*/React.createElement(Table.Body, null, monthArr.map(function (week, weekIndex) {
    return /*#__PURE__*/React.createElement(Table.Row, {
      justify: weekIndex === 0 ? 'flex-end' : 'flex-start',
      key: "week_".concat(weekIndex)
    }, week.map(function (day, dayIndex) {
      var isDateVisible = day.dateNumber !== undefined;
      var isDisabled = isDateVisible && isDateDisabled(day);
      var isSelected = !isDisabled && checkSameDate(day.value, selectedDate);
      return /*#__PURE__*/React.createElement(Table.Data, {
        className: "date_".concat(weekIndex, "_").concat(dayIndex, " C-DatePicker__DataCell"),
        key: "date_".concat(weekIndex, "_").concat(dayIndex)
      }, /*#__PURE__*/React.createElement(Button, {
        iconOnly: true,
        disabled: isDisabled,
        "aria-hidden": day.value ? null : 'true',
        "aria-label": day.value ? day.value : 'hidden',
        className: "\n                      C-DatePicker__DateButton --embeddedInComponent\n                      ".concat(day && isSelected ? 'isSelected' : '', "\n                      ").concat(isDateVisible ? '' : 'isHidden', "\n                      ").concat(isDisabled ? 'isDisabled' : '', "\n                    "),
        onClick: function onClick() {
          var formattedDate = formatDate(day.value, format);
          setDate(formattedDate, true);
          autoOk && setIsCalendarVisible(false);
        }
      }, day.dateNumber));
    }));
  })));
}
RawCalendarDates.displayName = 'CalendarDates';
var CalendarDates = /*#__PURE__*/React.memo(RawCalendarDates);

export { CalendarDates as default };
